<template>
  <ColumnChart
    :request-status="requestStatus"
    :categories="categories"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    :show-granularity="false"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import ColumnChart from '@/components/cards/models/ColumnChart';
import channelModel from '@/mixins/channel-model';
import cardsModel from '@/mixins/cards-model';
import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'GroupChannel',
  components: {
    ColumnChart,
  },
  mixins: [
    channelModel,
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: {},
      classifiedPercentage: 0,
    };
  },
  computed: {
    ...mapGetters('dashboard', ['activeDashboardFilters', 'activeGlobalFilter']),
    categories() {
      const filteredGroups = this.filter;
      const allGroups = this.rawSeries.all?.map(item => item.name) || [];

      return filteredGroups ? allGroups.filter(group => filteredGroups.includes(group)) : allGroups;
    },
    series() {
      const seriesObj = [];
      const filteredChannels = this.activeGlobalFilter?.channels_listening?.value.map(channel => channel.toLowerCase()) || [];

      const normalizedRawSeries = Object.keys(this.rawSeries).reduce((acc, key) => {
        acc[key.toLowerCase()] = this.rawSeries[key];
        return acc;
      }, {});

      const channels = Object.keys(normalizedRawSeries).filter(key => key !== 'all' && (filteredChannels.length === 0 || filteredChannels.includes(key)));

      channels.forEach(channel => {
        const channelData = {
          name: channel,
          data: [],
        };

        this.categories.forEach(groupName => {
          const item = normalizedRawSeries[channel]?.find(item => item.name === groupName);
          if (item) {
            channelData.data.push(item.total);
          } else {
            channelData.data.push(null);
          }
        });

        seriesObj.push(channelData);
      });
      return seriesObj;
    },
    cardOptions() {
      return {
        xAxis: {
          type: 'category',
          categories: this.categories,
        },
        legend: {
          enabled: true,
        },
        tooltip: {
          xDateFormat: this.xDateFormat,
        },
      };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringMultibar',
        serviceParams: {
          type: 'names',
        },
      })
        .then(response => {
          this.rawSeries = response.data || {};
          this.requestStatus = 'success';

          if (this.$attrs.filter) {
            this.filter = this.$attrs.filter?.names?.value || this.activeGlobalFilter?.names?.value;
          }

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
